import { useEffect, useRef } from "react";
import { useIntersectionObserver } from "web/react/hooks/use-intersection-observer/use-intersection-observer";
import analytics from "web/script/analytics/analytics";

// CW-3710: fires a single "viewed" event, the first time a section of the enhanced
// retailer Shopfront becomes visible. truncate:false because several of these
// categories (e.g. "retailer_description_button") exceed the legacy 16-char limit.
export function useShopfrontSectionImpression<T extends HTMLElement = HTMLDivElement>(
    category?: string,
    // Fraction of the section that must be on screen. Sections taller than the
    // viewport can never meet a fractional threshold, so those pass 0.
    threshold = 0.3
): React.RefObject<T> {
    const sectionRef = useRef<T>(null);
    const hasFired = useRef(false);
    const [isVisible] = useIntersectionObserver({ once: true, threshold }, sectionRef);

    useEffect(() => {
        if (category && isVisible && !hasFired.current) {
            hasFired.current = true;
            analytics.event({
                category,
                action: "viewed",
                nonInteraction: true,
                truncate: false,
            });
        }
    }, [isVisible, category]);

    return sectionRef;
}
